import React from 'react'
import { Stack, Grid, GridItem, Box, FormControl, FormLabel} from '@chakra-ui/react'
import { DatePickerInput } from 'components/react-hook-form-fields/date-picker'
import { dateFormat } from 'utils/date-time-utils'
import { useProjectExtraAttributes } from 'api/project-details'
import { ProjectExtraAttributesType } from 'types/project.type'

type OrderMiscProps = {
  ticketId?: number
  projectExtraAttributes?: ProjectExtraAttributesType
}
export const OrderMisc: React.FC <OrderMiscProps> = ({ ticketId }) => {
  const { data: projectExtraAttributes } = useProjectExtraAttributes(ticketId)

  const {
    approvedDate,
    awaitingDate,
    closedDate,
    contact1Date,
    contact2Date,
    estimatedDate,
    rejectedDate,
    reviseDate,
    scheduledDate,
    declineDate,
    draftDate,
    disputedDate,
    newDate,
  } = projectExtraAttributes || {}

  return (
    <>
      <Stack spacing="60px !important">
        <Box>
          <Grid templateColumns="repeat(3, 200px)" gap="30px">
            <GridItem>
              <FormControl height="40px" data-testid="draftDate">
                <FormLabel fontSize="14px" fontWeight={500} color="gray.700">
                  Draft
                </FormLabel>
                <DatePickerInput value={draftDate ? dateFormat(draftDate) : 'mm/dd/yyyy'} disable />
              </FormControl>
            </GridItem>
            <GridItem>
              <FormControl height="40px" data-testid="newDate">
                <FormLabel fontSize="14px" fontWeight={500} color="gray.700">
                  New
                </FormLabel>
                <DatePickerInput value={newDate ? dateFormat(newDate) : 'mm/dd/yyyy'} disable />
              </FormControl>
            </GridItem>
            <GridItem>
              <FormControl height="40px" data-testid="contact1Date">
                <FormLabel fontSize="14px" fontWeight={500} color="gray.700">
                  Contact 1
                </FormLabel>
                <DatePickerInput value={contact1Date ? dateFormat(contact1Date) : 'mm/dd/yyyy'} disable />
              </FormControl>
            </GridItem>
          </Grid>
        </Box>

        <Box>
          <Grid templateColumns="repeat(3, 200px)" gap="30px">
              <GridItem>
                <FormControl height="40px" data-testid="contact2Date">
                  <FormLabel fontSize="14px" fontWeight={500} color="gray.700">
                  Contact 2
                  </FormLabel>
                  <DatePickerInput value={contact2Date ? dateFormat(contact2Date) : 'mm/dd/yyyy'} disable />
                </FormControl>
              </GridItem>
              <GridItem>
                <FormControl height="40px" data-testid="scheduledDate">
                  <FormLabel fontSize="14px" fontWeight={500} color="gray.700">
                    Scheduled
                  </FormLabel>
                  <DatePickerInput value={scheduledDate ? dateFormat(scheduledDate) : 'mm/dd/yyyy'} disable />
                </FormControl>
              </GridItem>  
              <GridItem>
                <FormControl height="40px" data-testid="estimatedDate">
                  <FormLabel fontSize="14px" fontWeight={500} color="gray.700">
                    Estimated
                  </FormLabel>
                  <DatePickerInput value={estimatedDate ? dateFormat(estimatedDate) : 'mm/dd/yyyy'} disable />
                </FormControl>
              </GridItem>
          </Grid>
        </Box>

        <Box>
          <Grid templateColumns="repeat(3, 200px)" gap="30px">
              <GridItem>
                <FormControl height="40px" data-testid="awaitingDate">
                  <FormLabel fontSize="14px" fontWeight={500} color="gray.700">
                    Submitted
                  </FormLabel>
                  <DatePickerInput value={awaitingDate ? dateFormat(awaitingDate) : 'mm/dd/yyyy'} disable />
                </FormControl>
              </GridItem> 
              <GridItem>
                <FormControl height="40px" data-testid="approvedDate">
                  <FormLabel fontSize="14px" fontWeight={500} color="gray.700">
                  Approved
                  </FormLabel>
                  <DatePickerInput value={approvedDate ? dateFormat(approvedDate) : 'mm/dd/yyyy'} disable />
                </FormControl>
              </GridItem>
              <GridItem>
                <FormControl height="40px" data-testid="closedDate">
                  <FormLabel fontSize="14px" fontWeight={500} color="gray.700">
                    Closed
                  </FormLabel>
                  <DatePickerInput value={closedDate ? dateFormat(closedDate) : 'mm/dd/yyyy'} disable />
                </FormControl>
              </GridItem>
            </Grid>
        </Box>

        <Box>
          <Grid templateColumns="repeat(3, 200px)" gap="30px">
              <GridItem>
                <FormControl height="40px" data-testid="rejectedDate">
                  <FormLabel fontSize="14px" fontWeight={500} color="gray.700">
                    Rejected
                  </FormLabel>
                  <DatePickerInput value={rejectedDate ? dateFormat(rejectedDate) : 'mm/dd/yyyy'} disable />
                </FormControl>
              </GridItem>
              <GridItem>
                <FormControl height="40px" data-testid="reviseDate">
                  <FormLabel fontSize="14px" fontWeight={500} color="gray.700">
                    Revision
                  </FormLabel>
                  <DatePickerInput value={reviseDate ? dateFormat(reviseDate) : 'mm/dd/yyyy'} disable />
                </FormControl>
              </GridItem>
              <GridItem>
                <FormControl height="40px" data-testid="declineDate">
                  <FormLabel fontSize="14px" fontWeight={500} color="gray.700">
                    Declined
                  </FormLabel>
                  <DatePickerInput value={declineDate ? dateFormat(declineDate) : 'mm/dd/yyyy'} disable />
                </FormControl>
              </GridItem>
            </Grid>
        </Box>
        
        <Box>
          <Grid templateColumns="repeat(3, 200px)" gap="30px">
              <GridItem>
                <FormControl height="40px"  data-testid="disputedDate">
                  <FormLabel fontSize="14px" fontWeight={500} color="gray.700">
                    Disputed
                  </FormLabel>
                  <DatePickerInput value={disputedDate ? dateFormat(disputedDate) : 'mm/dd/yyyy'} disable />
                </FormControl>
              </GridItem>
            </Grid>{' '}
        </Box>
       
      </Stack>
    </>
  )
}
